/**
 * Javascript for pill bindings
 * @author Dan Pomeroy (dp@yext.com)
 */
goog.module('yext.location.pill');
goog.module.declareLegacyNamespace();

const UpdateDatesDialog = goog.require('yext.scheduledupdates.dialog.UpdateDatesDialog');

function bindPills() {
  $('.js-scheduled-updates-pill').click(function(e) {
    UpdateDatesDialog(e).show();
  });
}

exports = {
  bindPills,
};
